import { TABLE_NAMES } from "shared/types/enums";

import {
    CUSTOM_GROUP_NAMES,
    EVENT_NAMES,
    ResourceEventData,
    TABLE_ACTIONS
} from "./types";
import { useSignalREvent } from "./useSignalREvent";
import { useSignalRGroups } from "./useSignalRGroups";

export const useSignalRForTable = (
    tableName: TABLE_NAMES,
    ids: number[],
    isInnerTable: boolean,
    updateCallback: (data: ResourceEventData) => void,
    deleteCallback: (dataL: ResourceEventData) => void
) => {
    const allEventNames: Partial<Record<TABLE_NAMES, EVENT_NAMES>> = {
        [TABLE_NAMES.Companies]: EVENT_NAMES.Company,
        [TABLE_NAMES.DesktopLicenses]: EVENT_NAMES.License,
        [TABLE_NAMES.DeviceGroups]: EVENT_NAMES.DeviceGroup,
        [TABLE_NAMES.DeviceModels]: EVENT_NAMES.DeviceModel,
        [TABLE_NAMES.DeviceModelTaskCompatibilities]:
            EVENT_NAMES.DeviceModelTaskCompatibility,
        [TABLE_NAMES.Devices]: EVENT_NAMES.Device,
        [TABLE_NAMES.Files]: EVENT_NAMES.File,
        [TABLE_NAMES.ProductCodes]: EVENT_NAMES.ProductCode,
        [TABLE_NAMES.Roles]: EVENT_NAMES.Role,
        [TABLE_NAMES.TaskGroups]: EVENT_NAMES.TaskGroup, // only update
        [TABLE_NAMES.Tasks]: EVENT_NAMES.Task, // only update
        [TABLE_NAMES.Users]: EVENT_NAMES.User
    };

    const eventName = allEventNames[tableName];

    const groupName =
        tableName === TABLE_NAMES.DesktopLicenses
            ? CUSTOM_GROUP_NAMES.Licenses
            : tableName;

    const groups =
        !isInnerTable && eventName ? ids.map(id => `${groupName}.${id}`) : [];

    const fullEventName = (eventAction: TABLE_ACTIONS) =>
        !isInnerTable && eventName ? `${eventName}_${eventAction}` : undefined;

    useSignalREvent<ResourceEventData>(
        fullEventName(TABLE_ACTIONS.Updating),
        data => updateCallback(data)
    );

    useSignalREvent<ResourceEventData>(
        fullEventName(TABLE_ACTIONS.Deleting),
        data => deleteCallback(data)
    );

    useSignalRGroups(groups);
};
